import { ReactComponent as GsOne } from "../icon/home/swiperbottom/模型介绍.svg";
import { ReactComponent as GsTwo } from "../icon/home/swiperbottom/模型训练.svg";
import { ReactComponent as GsThree } from "../icon/home/swiperbottom/预测服务.svg";
import { ReactComponent as GsFour } from "../icon/home/swiperbottom/亲本质量.svg";
import { ReactComponent as GsPlusTrain } from "../icon/home/swiperbottom/模型训练.svg";
import { ReactComponent as GsPlusMating } from "../icon/home/swiperbottom/亲本质量.svg";
const LeftMenuItem = [
  {
    key: "left1",
    label: (
      <a
        href="#/Breeding/modelinter/"
        style={{ display: "flex", alignItems: "center" }}
      >
        <GsOne width={20} style={{ margin: "0 5px" }} />
        Model Introduction
      </a>
    ),
  },
  {
    key: "left2",
    label: (
      <a
        href="#/Breeding/gsmodel/"
        style={{ display: "flex", alignItems: "center" }}
      >
        <GsTwo width={20} style={{ margin: "0 5px" }} />
        GS Model Training
      </a>
    ),
  },
  {
    key: "left3",
    label: (
      <a
        href="#/Breeding/predict/"
        style={{ display: "flex", alignItems: "center" }}
      >
        <GsThree width={20} style={{ margin: "0 5px" }} />
        Predict Phenotype
      </a>
    ),
  },
  {
    key: "left4",
    label: (
      <a
        href="#/Breeding/parent/"
        style={{ display: "flex", alignItems: "center" }}
      >
        <GsFour width={20} style={{ margin: "0 5px" }} />
        Parental Selection
      </a>
    ),
  },
  // {
  //   key: "left5",
  //   label: (
  //     <a href="#/Breeding/ablup/" style={{ display: "flex", alignItems: "center" }}>
  //       <GsPlusTrain width={20} style={{ margin: "0 5px" }} />
  //       ABLUP Model Training
  //     </a>
  //   ),
  // },
  // {
  //   key: "left6",
  //   label: (
  //     <a href="#/Breeding/ssgblup/" style={{ display: "flex", alignItems: "center" }}>
  //       <GsPlusTrain width={20} style={{ margin: "0 5px" }} />
  //       SSGBLUP Model Training
  //     </a>
  //   ),
  // },
  // {
  //   key: "left7",
  //   label: (
  //     <a href="#/Breeding/optimalmating/" style={{ display: "flex", alignItems: "center" }}>
  //       <GsPlusMating width={20} style={{ margin: "0 5px" }} />
  //       Optimal Mating
  //     </a>
  //   ),
  // },
];
export default LeftMenuItem;
